'use client';
import React from 'react';

const footerLinks = {
  services: [
    { label: 'Stack Parking System', href: '#products' },
    { label: 'Puzzle Parking System', href: '#products' },
    { label: 'Tower Parking System', href: '#products' },
    { label: 'Shuttle / Robotic Parking', href: '#products' },
    { label: 'Rotary Parking System', href: '#products' },
    { label: 'Horizontal Circulation', href: '#products' },
    { label: 'Two Wheeler Parking', href: '#products' },
  ],
  quickLinks: [
    { label: 'Home', href: '#home' },
    { label: 'About Us', href: '#about' },
    { label: 'Products', href: '#products' },
    { label: 'Projects', href: '#projects' },
    { label: 'Why Choose Us', href: '#why-us' },
    { label: 'Contact', href: '#contact' },
  ],
};

export default function Footer() {
  const handleNavClick = (href: string) => {
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer
      style={{ backgroundColor: '#1C3C85', fontFamily: 'Ubuntu, sans-serif' }}
    >
      {/* Main Footer */}
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            {/* Logo */}
            <div className="flex items-center gap-3 mb-5">
              <div className="bg-white rounded-[10px] px-3 py-2 inline-flex items-center">
                <img
                  src="/assets/images/Screenshot_20260806-003009-1785956437897.png"
                  alt="Bhargav Engineering Logo"
                  className="h-12 w-auto object-contain"
                />
              </div>
            </div>
            <p
              className="text-white/70 mb-6"
              style={{ fontSize: '15px', lineHeight: '24px', fontFamily: 'Ubuntu, sans-serif' }}
            >
              We are a young, modern and futuristic technology-driven Automated Car Parking Systems solution provider — concept, design, manufacture, supply, install and maintain.
            </p>
            {/* Social */}
            <div>
              <p className="text-white/50 text-[13px] mb-3 font-medium" style={{ fontFamily: 'Ubuntu, sans-serif' }}>Follow Us</p>
              <div className="flex gap-3">
                {[
                  { name: 'Facebook', icon: <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" /> },
                  { name: 'LinkedIn', icon: <><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></> },
                  { name: 'Instagram', icon: <><rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="2"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" fill="none" stroke="currentColor" strokeWidth="2"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="currentColor" strokeWidth="2"/></> },
                ].map((social) => (
                  <a
                    key={social.name}
                    href="#"
                    className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:border-[#00AAE2] hover:text-[#00AAE2] transition-all duration-300"
                    aria-label={social.name}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      {social.icon}
                    </svg>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <a
              href="#products"
              onClick={(e) => { e.preventDefault(); handleNavClick('#products'); }}
              className="text-white font-medium text-[17px] mb-5 block hover:text-[#00AAE2] transition-colors"
              style={{ fontFamily: 'Ubuntu, sans-serif' }}
            >
              Services
            </a>
            <nav>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.services.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                      className="text-white/60 hover:text-white transition-colors duration-300"
                      style={{ fontSize: '15px', fontFamily: 'Ubuntu, sans-serif' }}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Quick Links */}
          <div>
            <p className="text-white font-medium text-[17px] mb-5" style={{ fontFamily: 'Ubuntu, sans-serif' }}>Quick Links</p>
            <nav>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.quickLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                      className="text-white/60 hover:text-white transition-colors duration-300"
                      style={{ fontSize: '15px', fontFamily: 'Ubuntu, sans-serif' }}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <p className="text-white font-medium text-[17px] mb-5" style={{ fontFamily: 'Ubuntu, sans-serif' }}>Get In Touch</p>
            <ul className="flex flex-col gap-4">
              <li className="flex gap-3 items-start">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00AAE2" strokeWidth="2" className="mt-0.5 flex-shrink-0">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <span
                  className="text-white/60"
                  style={{ fontSize: '14px', lineHeight: '22px', fontFamily: 'Ubuntu, sans-serif' }}
                >
                  Warehouse No.8, 5A And 6A 183/1, Kadaiya, Nani Daman, Daman & Diu, India - 396210
                </span>
              </li>
              <li className="flex gap-3 items-center">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00AAE2" strokeWidth="2" className="flex-shrink-0">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.38 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.96a16 16 0 0 0 6.13 6.13l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <a
                  href="tel:+918238831338"
                  className="text-white/60 hover:text-white transition-colors"
                  style={{ fontSize: '15px', fontFamily: 'Ubuntu, sans-serif' }}
                >
                  +91 8238831338
                </a>
              </li>
              <li className="flex gap-3 items-center">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00AAE2" strokeWidth="2" className="flex-shrink-0">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                <a
                  href="mailto:info.bhargavengg@gmail.com"
                  className="text-white/60 hover:text-white transition-colors"
                  style={{ fontSize: '14px', fontFamily: 'Ubuntu, sans-serif' }}
                >
                  info.bhargavengg@gmail.com
                </a>
              </li>
              <li className="flex gap-3 items-center">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00AAE2" strokeWidth="2" className="flex-shrink-0">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                <a
                  href="mailto:bhargavengg2012@gmail.com"
                  className="text-white/60 hover:text-white transition-colors"
                  style={{ fontSize: '14px', fontFamily: 'Ubuntu, sans-serif' }}
                >
                  bhargavengg2012@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div
        className="border-t"
        style={{ borderColor: 'rgba(255,255,255,0.1)' }}
      >
        <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p
            className="text-white/50"
            style={{ fontSize: '14px', fontFamily: 'Ubuntu, sans-serif' }}
          >
            &copy; Copyright 2024 Bhargav Parking. All Rights Reserved.
          </p>
          <nav>
            <ul className="flex gap-5">
              {['Privacy Policy', 'Terms & Conditions', 'Sitemap'].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="text-white/50 hover:text-white transition-colors"
                    style={{ fontSize: '13px', fontFamily: 'Ubuntu, sans-serif' }}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}
